import ExaminationEventProvider from './ExaminationEventProvider';

export default ExaminationEventProvider;
